import { Component } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import SystemUtilities from "../../system-utilities"
import { Observable, Subscription } from 'rxjs';
import { SystemSiteService } from '../../services/system-site.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
declare interface TableData {
  headerRow: string[];
  dataRows: string[][];
}
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {
  Data: any = [];
  site_data: any;
  processed_data: any = [];
  selectable_databases: any = [];
  ModalData: any = {};
  loading: boolean = true;
  closeResult: string;
  loginSubscription: Subscription = null;
  downloadSubscription: Subscription = null;
  downloadFileSubscription: Subscription = null;
  download_url: string = `${environment.site_URL}`;

  user_id: string = "";
  one_time_pin: string = "";
  password_new: string = "";
  password_new_repeat: string = "";
  paramsSubscription: Subscription;
  resetPasswordSubscription: Subscription = null;

  public result_message = ""
  constructor(private modalService: NgbModal, private systemSiteService: SystemSiteService, private route: ActivatedRoute, private router: Router) { }



  ngOnInit() {



    this.paramsSubscription = this.route.params.subscribe(params => {
      this.user_id = params.user_id
    });



    this.LoadData();




  }


  LoadData() {
    this.downloadSubscription = this.systemSiteService.get_downloads("software").subscribe({
      next: (data) => {
        console.log(data.result_data)
        this.Data = data.result_data;
        this.loading = false;
      },
      error: (error) => { console.log(error) },
    })
  }


  password_new_change(event) {

    if (this.password_new != this.password_new_repeat) {
      this.result_message = "Password do not match!"
    } else {
      this.result_message = ""
    }
  }



  password_new_repeat_change(event) {


    if (this.password_new != this.password_new_repeat) {
      this.result_message = "Password do not match!"
    } else {
      this.result_message = ""
    }


  }







  reset_password(event) {



    console.log("Password reset!")




    let user_data = JSON.stringify({
      "user_id": this.user_id,
      "password": this.password_new,
      "otp": this.one_time_pin,
    });



    this.resetPasswordSubscription = this.systemSiteService.reset_password(user_data).subscribe({
      next: async (data) => {
        console.log(data.result_data);
        this.loading = true;

        let result_data = data.result_data;

        if (result_data['UserConfirmResult'] == null) {
          console.log("Could not set password!");
          this.result_message = "Error resetting password! Please contact support!"
        } else {




          this.router.navigate(['/login']);

        }


      },
      error: (error) => { console.log(error); },
    })

  }




  downloadFile(id: string, filename: string, mimetype : string ,  download_url: string): void {

    const link = document.createElement('a');
    link.href = download_url;
    link.download = filename
    link.type = mimetype
    //link.setAttribute('download', `${filename}`);  // Adjust the file extension/name as needed
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);



    // this.systemSiteService.get_download_file(id).subscribe(data => {
    //   const blob = new Blob([data], { type: mimetype });  // Adjust the MIME type as needed
    //   const url = window.URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.setAttribute('download', `${filename}`);  // Adjust the file extension/name as needed
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   window.URL.revokeObjectURL(url);
    //   this.downloading = false;


    //   this.modalReference.close();

    // });



  }



  ngOnDestroy(): void {
    if (this.loginSubscription)
      this.loginSubscription.unsubscribe();
    if (this.downloadSubscription)
      this.downloadSubscription.unsubscribe();
    if (this.downloadSubscription)
      this.downloadSubscription.unsubscribe();
    if (this.resetPasswordSubscription)
      this.resetPasswordSubscription.unsubscribe();
    if (this.downloadFileSubscription)
      this.downloadFileSubscription.unsubscribe();
  }


}
